import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookmarkFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 7,
	height: 14,
	viewBox: "0 0 7 14",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M-7.64949e-08 12.25C-7.6494e-08 14 -1.19209e-07 14 0.65565 14L6.66578 14C6.78871 14 6.91165 13.8177 6.96629 13.526C7.02092 13.2344 7.00727 12.9062 6.93897 12.651L5 7L6.93897 1.38542C7.00726 1.13021 7.02092 0.765626 6.96629 0.473959C6.91165 0.182292 6.78871 -2.96744e-07 6.66578 -2.91371e-07L0.65565 -2.86594e-08C-1.5913e-08 0 -5.35464e-07 0 -5.35465e-07 1.75L-1.36084e-07 10.8868L-7.64949e-08 12.25Z",
		fill: "currentColor"
	})
});
export default SvgBookmarkFlag;
